import React from "react";
import { Link } from "react-router-dom";
import { ROUTES_PATH } from "shared/constants/routesPath";
import GoBack from "shared/ui/GoBack";
import s from "./style.module.scss";
import HistoryList from "widgets/HistoryList";

const History: React.FC = () => {
  return (
    <main className={s.history}>
      <GoBack black />

      <Link to={ROUTES_PATH.SUPPORT}>Обратная связь</Link>

      <section>
        <h1>История начисления</h1>

        <HistoryList />
      </section>
    </main>
  );
};

export default History;
